import moment from "moment";

const transposeCommonSelectedCommonDate = dateParam => {
    return {"today": moment().startOf('day').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "24h": moment().subtract(1, 'days').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "yesterday": moment().subtract(1,'days').startOf('day').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "now": moment().format("YYYY-MM-DDTHH:mm:ssZZ"),
        "7d":  moment().subtract(6, 'days').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "90d": moment().subtract(89, 'days').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "1y": moment().subtract(1, 'years').format("YYYY-MM-DDTHH:mm:ssZZ")}[dateParam];
};

const getStartOfDay=() => {
    return moment().startOf("days").subtract(1,'seconds').format("YYYY-MM-DDTHH:mm:ssZZ");
};

const transposeToSelectedRelativeDate = (number, relativeDateParam) => {
    return {"secondsAgo": moment().subtract(number,'seconds').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "minutesAgo": moment().subtract(number, 'minutes').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "hoursAgo": moment().subtract(number, 'hours').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "daysAgo":  moment().subtract(number, 'days').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "weeksAgo":  moment().subtract(number, 'weeks').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "monthsAgo": moment().subtract(number, 'months').format("YYYY-MM-DDTHH:mm:ssZZ"),
        "yearsAgo": moment().subtract(number, 'years').format("YYYY-MM-DDTHH:mm:ssZZ")}[relativeDateParam];
};

const formatDate = date => {
    return moment(date).format("YYYY-MM-DDTHH:mm:ssZZ");
};

export {
    transposeCommonSelectedCommonDate,
    formatDate,
    transposeToSelectedRelativeDate,
    getStartOfDay
}